import { render, staticRenderFns } from "./ItemWithChildren.vue?vue&type=template&id=0cd99b57&scoped=true&"
import script from "./ItemWithChildren.vue?vue&type=script&lang=js&"
export * from "./ItemWithChildren.vue?vue&type=script&lang=js&"
import style0 from "./ItemWithChildren.vue?vue&type=style&index=0&id=0cd99b57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd99b57",
  null
  
)

export default component.exports